type PatientId = number;
type PrintTemplateId = number;

export const getConsentTemplateToken = (patientId: PatientId, printTemplateId: PrintTemplateId): string =>
   `patient-${patientId}-consentTemplate-${printTemplateId}`;
